import React, { useEffect } from "react";
import Pageslayout from "../../Layouts/Pageslayout";
import PageIntro from "../../components/PageIntro";
import PropertyGrid from "../../components/PropertyGrid";
import { useSelector } from "react-redux";
import selectedOptions from "../../app/reducers/selectedOptions";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser, faStar, faHeart } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
const Index = ({ title, description }) => {
  const navigate = useNavigate();
  const favouriteproduct = useSelector((state) => state.favouriteproduct);
  console.log(favouriteproduct, "favouriteproduct");
  return (
    <Pageslayout
      title="Searched results"
      description="Properties related to your search"
      active="true"
    >
      <div className="w-full py-4  px-2 md:px-8 lg:px-8 bg-[#f5f5f5] flex justify-center items-center gap-2 ">
        <FontAwesomeIcon
          icon={faHeart}
          size="md"
          style={{ color: "#1f2937" }}
          className="px-1 text-[16px]"
        />
        <p className="font-semibold text-xl text-center">Favourite Listings</p>
      </div>

      {favouriteproduct?.length < 1 ? (
        <div className="flex justify-center items-center py-20">
          {/* <img
            src="
        /assets/loader/loader.png"
            alt=""
          /> */}
          <p>Nothing added to favourites yet</p>
        </div>
      ) : (
        <>
          <div className="w-full  ">
            <div className="flex gap-4  flex-wrap lg:flex-nowrap w-full py-4  px-2 md:px-8 lg:px-8">
              <PropertyGrid properties={favouriteproduct} />
            </div>
          </div>
        </>
      )}
    </Pageslayout>
  );
};
export default Index;
